<template>
  <div class="box">
    <div>
      <van-nav-bar
        title="考试宝典测评报告"
        left-arrow
        v-if="initial != 0"
        @click-left="toHome"
      />
    </div>
    <van-swipe
      style="height: 100vh"
      vertical
      :show-indicators="indicators"
      :touchable="touchable"
      :stop-propagation="touchable"
      :initial-swipe="initial"
      @change="swipes"
      duration="1000"
    >
      <van-swipe-item>
        <div
          id="app1"
          ref="app1"
          @scroll="handleScroll"
          class="contentArea contentArea_as"
        >
          <div class="swipeItem_a">
            <div class="swipeItem_title">考试宝典测评报告</div>
            <div class="swipeItem_titleA">
              <div class="determine">测评报告</div>
              <div class="subject">科目：{{ cname }}</div>
            </div>
            <div class="swipeItem_a_img">
              <img src="../assets/bg1.png" alt="" />
            </div>
          </div>
          <div class="lookOver" @click="lookOverClick">开始查看报告</div>
        </div>
        <!-- <van-nav-bar title="考试宝典测评报告" /> -->
      </van-swipe-item>
      <van-swipe-item>
        <div id="app2" ref="app2" @scroll="handleScroll" class="contentArea">
          <div class="bulletin">
            <div class="circumstances circumstances_a circumstances_b">
              整体情况
            </div>
            <div class="bulletin_average">
              <div class="average">
                <span>本卷首次作答平均分：</span>{{ statisticsInfo.agv_score }}
              </div>
              <div class="average">
                <span>本卷首次作答最高分：</span>{{ statisticsInfo.max_score }}
              </div>
            </div>
            <div class="circumstancestime">
              亲爱的 <span>{{ dataList.user }}</span> 同学:
            </div>
            <div class="circumstancestime">
              您于
              {{ referringTime }} 进行测试，用时{{
                duration
              }}，以下是您的测试结果
            </div>
            <div class="fruit">
              <div class="fruit_a">
                <div class="fruitOutside">
                  <div class="fruitOutside_a">测试题题量</div>
                  <div class="fruitOutside_b">{{ totalQuantity }}题</div>
                </div>
                <div class="fruitOutside">
                  <div class="fruitOutside_a">测试完成度</div>
                  <div class="fruitOutside_b">{{ accuracyBox }}</div>
                </div>
                <div class="fruitOutside">
                  <div class="fruitOutside_a">测试时长</div>
                  <div class="fruitOutside_b">{{ duration }}</div>
                </div>
                <div class="fruitOutside">
                  <div class="fruitOutside_a">测试成绩</div>
                  <div class="fruitOutside_b">{{ scoreBox }}分</div>
                </div>
                <div class="fruitOutside">
                  <div class="fruitOutside_a">测试水平</div>
                  <div class="fruitOutside_b">
                    <span v-if="accuracyPercentage >= 60">及格</span>
                    <span v-else>不及格</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="summarizeBriefly">
              <!-- 成绩≤60% -->
              <div v-if="accuracyPercentage <= 60">
                知识点掌握较薄弱，距离应试平均水平还有一定的差距，但不要放弃加强知识点的理解，坚持每天<span
                  >掌握5个知识点</span
                >
                ！
              </div>
              <!-- 60%＜成绩＜79% -->
              <div v-if="accuracyPercentage > 60 && accuracyPercentage < 79">
                知识点掌握一般，要稳定通过考试还需要继续努力，坚持每天<span>掌握5个知识点</span>，考试不止加5分！
              </div>
              <!-- 成绩≥80% -->
              <div v-if="accuracyPercentage >= 80">
                真棒！知识点掌握得很好，请继续保持！今天<span>掌握5个知识点</span>，明天考试就能成功上岸！
              </div>
            </div>
          </div>
        </div>
      </van-swipe-item>

      <van-swipe-item>
        <div id="app3" ref="app3" @scroll="handleScroll" class="contentArea">
          <div class="circumstances circumstances_a">分析结果</div>
          <div class="analyticResult">
            <div class="result">
              <div class="resultCell resultCell_fz">
                <div class="resultCell_a">题型</div>
                <div class="resultCell_b">正确题数/总题数</div>
                <div class="resultCell_c">掌握度</div>
              </div>
              <div
                class="resultCell"
                v-for="(item, index) in myChartdata.ARFields"
                :key="index"
              >
                <div class="resultCell_a">{{ item.text }}</div>
                <div class="resultCell_b">
                  {{ myChartdata.RightCount[index] }}/{{ item.max }}
                </div>
                <div class="resultCell_c">
                  {{
                    (myChartdata.RightCount[index] / item.max).toFixed(1) * 100
                  }}%
                </div>
              </div>
            </div>
            <div class="viewParsing" @click="examineClick">查看答案解析</div>
            <div ref="main" style="width: 100%; height: 200px"></div>
            <div class="interpretation">
              <div class="interpretation_title">结果分析</div>
              <div>
                做题过程要注意审题哦！现在我们是复习测试阶段，重点还是要掌握各知识点；同时在审题的时候一定要找准题眼，不确定的先使用排除法排除，剩下的模糊点可以联想类似的知识点来判断；如果某一题型错错得较多，可以针对本题型进行专项的题型训练。
              </div>
            </div>
          </div>
        </div>
      </van-swipe-item>
      <van-swipe-item>
        <div id="app4" ref="app4" @scroll="handleScroll" class="contentArea">
          <div class="circumstances circumstances_a">题型分析</div>
          <div class="analyticResult">
            <div class="questionTypes">
              <div
                v-for="(item, index) in myChartdata.ARFields"
                :key="index"
                :class="
                  indexs == index ? 'questionTypes_as' : 'questionTypes_a'
                "
                @click="questionTypesClick(index, item)"
              >
                {{ item.text }}
              </div>
            </div>
            <div class="proportionBox">
              <div class="proportion">
                <div class="proportion_a">题目比重</div>
                <div>{{ proportionData * 100 }}%</div>
              </div>
              <div>
                <van-progress
                  :percentage="proportionData * 100"
                  pivot-color="#6E92EB"
                />
              </div>
              <div class="proportion">
                <div class="proportion_a">答题正确率</div>
                <div>{{ accuracyData * 100 }}%</div>
              </div>
              <div>
                <van-progress
                  :percentage="accuracyData * 100"
                  pivot-color="#6E92EB"
                />
              </div>
            </div>

            <div class="level">掌握程度</div>
            <div class="degree">
              <div
                class="degree_a"
                v-for="(item, index) in degreeData"
                :key="index"
              >
                <div class="handstand" v-if="accuracyNameBox == item"></div>
                <div class="handstands" v-else></div>
                <div
                  :class="accuracyNameBox == item ? 'degree_jds' : 'degree_jd'"
                ></div>
                <div class="degree_title">{{ item }}</div>
              </div>
            </div>
          </div>
        </div>
      </van-swipe-item>
      <van-swipe-item v-if="chapter.length > 0 && 1==2">
        <div id="app5" ref="app5" @scroll="handleScroll" class="contentArea">
          <div class="circumstances circumstances_a">章节分析</div>
          <div class="analyticResult">
            <div class="result" >
              <div class="resultCell">
                <div class="resultCell_a">章节名称</div>
                <div class="resultCell_b">正确题数/总题数</div>
                <div class="resultCell_c">掌握度</div>
              </div>
              <div v-for="(item, index) in chapter" :key="index">
                <div class="resultCell resultCell_chapter">
                  <div class="resultCell_a" @click="toggleChapter(index)">
                    <span>{{ item.Name }}</span>
                    <span class="icon-arrow-down" v-if="item.Childs && item.Childs.length > 0 && expandedChapters[index]">
                      {{ '▼' }}
                    </span>
                    <span class="icon-arrow-right" v-if="item.Childs && item.Childs.length > 0 && !expandedChapters[index]">
                      {{ '▶' }}
                    </span>
                  </div>
                  <div class="resultCell_b" @click="toggleChapter(index)">{{ item.correct_total}}/ {{ item.total }}</div>
                  <div class="resultCell_c" @click="toggleChapter(index)" v-if="item.status>0"><font color="green">掌握</font></div>
                  <div class="resultCell_c" @click="toggleChapter(index)" v-else><font color="red">未掌握</font></div>
                </div>
                <!-- 子章节内容 -->
                <div v-if="expandedChapters[index] && item.Childs && item.Childs.length > 0">
                  <div class="resultCell childChapter" v-for="(child, childIndex) in item.Childs" :key="'child-item-' + childIndex">
                    <div class="resultCell_a" style="padding-left: 2px;">{{ child.Name }}</div>
                    <div class="resultCell_b">{{ child.testUser.correct_total }}/{{ child.testUser.total }}</div>
                    <div class="resultCell_c" v-if="child.testUser.status>0"><font color="green">掌握</font></div>
                    <div class="resultCell_c" v-else><font color="red">未掌握</font></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </van-swipe-item>
      <van-swipe-item>
        <div
          id="app6"
          ref="app6"
          @scroll="handleScroll"
          class="contentArea_a contentArea"
        >
          <div class="circumstances circumstances_a">总结</div>
          <div class="analyticResult analyticResult_summarizes">
            <!-- 优秀（≥81%） -->
            <div
              class="analyticResult_summarize"
              v-if="accuracyPercentage >= 81"
            >
              <p>你真棒！</p>
              <p>
                本次测试涉及的知识点整体掌握的很好，请保持这种好的状态，一举通过考试！有做错的题可以再仔细研究一下，找出错误原因，透彻理解相关的知识点，最好过一段时间再重新测试一下这些知识点。
              </p>
              <p>
                本次测试成绩仅代表你此刻的专业水平和应试能力，需要结合你的实际情况制定学习计划进行持续的学习，持之以恒，你一定会取得满意的结果
              </p>
              <p>有什么疑问可以联系班主任哦！</p>
            </div>
            <!-- 良好（60%≥x≥80% -->
            <div
              class="analyticResult_summarize"
              v-if="accuracyPercentage >= 60 && accuracyPercentage <= 80"
            >
              <p>再接再厉！</p>
              <p>
                还有部分知识点还没有掌握哦，看看错题和解析，结合里面的知识点可以看看对应的课程内容或教材，重新复习一下吧，记得要做一下笔记！复习完毕后再次做一下错题和涉及知识点的题目，巩固学习成果。
              </p>
              <p>
                本次测试成绩仅代表你此刻的专业水平和应试能力，需要结合你的实际情况制定学习计划进行持续的学习，持之以恒，你一定会取得满意的结果。
              </p>
              <p>有什么疑问可以联系班主任哦！</p>
            </div>
            <!-- 不合格（≤59%） -->
            <div
              class="analyticResult_summarize"
              v-if="accuracyPercentage <= 59"
            >
              <p>
                当前知识点掌握还有很大进步空间！稳扎稳打，加强知识点的理解，一切都会越来越好！
                学习建议：先从基础的章节知识点开始学习，过程中记得做好笔记；在完成一个知识点的学习后配合练习题进行巩固；并每隔一周进行混合知识的练习。
              </p>
              <p>
                本次测试成绩仅代表你此刻的专业水平和应试能力，需要结合你的实际情况制定学习计划进行持续的学习，持之以恒，你一定会取得满意的结果。
              </p>
              <p>有什么疑问可以联系班主任哦！</p>
            </div>
          </div>
        </div>
      </van-swipe-item>
    </van-swipe>
    <div class="examine" v-if="initial != '5' && initial != '0'">
      <div v-if="type != 1">
        <v-touch
          v-on:swipeup="swiperup"
          v-on:swipedown="swiperdown"
          class="wrapper v-touch"
          tag="div"
        >
          <img src="../assets/bg3.png" alt="" />
          <div>上滑开始查看报告</div>
        </v-touch>
      </div>
      <div class="swiperupCls">
        <span class="swiperupCls_a" @click="swiperupLeft">上一页</span>
        <span @click="swiperup">下一页</span>
      </div>
    </div>
    <div class="examine examines" v-if="initial == '5'">
      <div class="examines_a" @click="reView">重新查看报告</div>
      <div class="examines_b" @click="examineClick">查看答案解析</div>
    </div>
  </div>
</template>
<script>
import { getOne, examConfig } from "../api/api";
import * as echarts from "echarts";
import { parse } from "qs";

export default {
  data() {
    return {
      indicators: false,
      touchable: false,
      initial: "0",
      timeOutEvent: 0,
      startX: "",
      startY: "",
      moveX: "",
      startX: "",
      fixed: true,
      scrollHeight1: "",
      scrollHeight2: "",
      scrollHeight3: "",
      scrollHeight4: "",
      scrollHeight5: "",
      scrollHeight6: "",
      indexs: 0,
      dataList: "",
      questionTypesData: ["单选题", "多选题", "案例分析题", "共用题干单选题"],
      degreeData: ["不足", "了解", "熟悉", "掌握", "精通"],
      id: "",
      referringTime: "", //提交时间
      duration: "", //时长
      imgbox: [],
      answerBox: [],
      quantitydata: [],
      totalQuantity: "",
      accuracyBox: "",
      scoreBox: "",
      accuracyPercentage: 0,
      myChartdata: [],
      proportionData: "",
      accuracyData: "",
      zfsData: [],
      accuracyNameBox: "",
      type: 0,
      cname: "",
      key: "",
      statisticsInfo: [],
      expandedChapters: [],
      chapter: [],
    };
  },
  created() {
    this.id = this.$route.query.id;
    this.key = this.$route.query.key;
    this.type = this.$route.query.type;
  },
  mounted() {
    window.addEventListener("scroll", this.scrollToTop);
    //判断每个是否有滚动条，只对存在的组件计算
    const apps = [
      { ref: this.$refs.app1, property: 'scrollHeight1' },
      { ref: this.$refs.app2, property: 'scrollHeight2' },
      { ref: this.$refs.app3, property: 'scrollHeight3' },
      { ref: this.$refs.app4, property: 'scrollHeight4' },
      { ref: this.$refs.app5, property: 'scrollHeight5' },
      { ref: this.$refs.app6, property: 'scrollHeight6' }
    ];

    apps.forEach(app => {
      if (app.ref) {
        this[app.property] = app.ref.scrollHeight - app.ref.clientHeight;
      } else {
        this[app.property] = 0;
      }
    });
    //判断是否一页显示完全
    if (this.scrollHeight1 > 0) {
    }
    var data = {
      key: this.key,
    };
    var that = this;
    getOne(data).then((res) => {
      this.dataList = res.data;
      var datas = res.data.data;
      this.chapter = datas?.chapter || [];
      //平均分和最高分
      this.statisticsInfo = res.data.data.statisticsInfo.info[0];
      let StyleItems = datas.testData.test.test;
      let StyleItems_a = datas.testData.test.test;
      localStorage.setItem(
        "topicAnswer",
        JSON.stringify(this.assembleData(StyleItems_a, datas.info).info)
      );
      var Style = datas.testData.test.test.StyleItems;
      var Styledata = [];
      var answerBox = new Array(); //把后台接口返回所有类型题目拆分储存在一个数组里面，
      for (var i in StyleItems) {
        //循环题目类型对数组
        //ATEST
        Styledata.push(StyleItems[i].Style);
        if (
          StyleItems[i].Type == "ATEST" ||
          StyleItems[i].Type == "PDTEST" ||
          StyleItems[i].Type == "XTEST"
        ) {
          let TestItems = StyleItems[i].TestItems;
          for (let j in TestItems) {
            //循环题目类型下的选项
            //把需要用到的字段，加到answerBox数组里面，方便判断类型
            TestItems[j]["Type"] = StyleItems[i].Type; //判断是否单选多选
            TestItems[j]["SubType"] = StyleItems[i].SubType; //"单项"
            TestItems[j]["Style"] = StyleItems[i].Style; //"B1型题"
            TestItems[j]["StyleID"] = StyleItems[i].StyleID; //"B1型题"
            TestItems[j]["Score"] = StyleItems[i].Score; //"得分"
            TestItems[j]["FrontTitle"] = ""; //
            TestItems[j]["AnswerArray"] = TestItems[j].Answer.split(""); //用于判断答案是否颜色选中

            if (TestItems[j]["Type"] == "PDTEST") {
              let Content = [
                {
                  Content: "对",
                  ItemName: "A",
                },
                {
                  Content: "错",
                  ItemName: "B",
                },
              ];
              TestItems[j]["SelectedItems"] = Content; //"B1型题"
              TestItems[j]["UserNote"] = "";
            }

            for (let w in TestItems[j].SelectedItems) {
              //在题目存入一个true,false,状态，方便控制题目是否选中状态
              TestItems[j].SelectedItems[w]["open"] = false;
            }
            //把用户操作数据放进题目里
            answerBox.push(TestItems[j]);
          }
        }
        // A3TEST(A3TestItems)
        if (StyleItems[i].Type == "A3TEST") {
          let TestItems = StyleItems[i].TestItems;
          for (let j in TestItems) {
            //循环题目类型下的选项
            let TestItemsb = TestItems[j].A3TestItems;
            for (let b in TestItemsb) {
              TestItemsb[b]["SubType"] = StyleItems[i].SubType; //"单项"
              TestItemsb[b]["Style"] = StyleItems[i].Style; //"B1型题"
              TestItemsb[b]["FrontTitle"] = TestItems[j].FrontTitle; //主干
              TestItemsb[b]["Type"] = StyleItems[i].Type; //判断是否单选多选
              TestItemsb[b]["StyleID"] = StyleItems[i].StyleID; //"B1型题"
              TestItemsb[b]["AllTestID"] = TestItems[j].AllTestID;
              TestItemsb[b]["A3TestID"] = TestItems[j].A3TestID;
              TestItemsb[b]["CptID"] = TestItems[j].CptID;
              TestItemsb[b]["IsFav"] = TestItems[j].IsFav;
              TestItemsb[b]["SbjID"] = TestItems[j].SbjID;
              TestItemsb[b]["Score"] = StyleItems[i].Score;
              TestItemsb[b]["SrcID"] = TestItems[j].SrcID;
              TestItemsb[b]["StyleType"] = TestItems[j].StyleType;
              TestItemsb[b]["AnswerArray"] = TestItemsb[b].Answer.split(""); //用于判断答案是否颜色选中

              for (let v in TestItemsb[b].SelectedItems) {
                TestItemsb[b].SelectedItems[v]["open"] = false;
              }
              answerBox.push(TestItemsb[b]);
            }
          }
        }
        //BTEST(BTestItems)
        if (StyleItems[i].Type == "BTEST") {
          let TestItems = StyleItems[i].TestItems;
          for (let j in TestItems) {
            //循环题目类型下的选项
            let TestItemsb = TestItems[j].BTestItems;
            for (let b in TestItemsb) {
              TestItemsb[b]["SubType"] = StyleItems[i].SubType; //"单项"
              TestItemsb[b]["Style"] = StyleItems[i].Style; //"B1型题"
              TestItemsb[b]["SelectedItems"] = JSON.parse(
                JSON.stringify(TestItems[j].SelectedItems)
              ); //"问题 深拷贝"
              TestItemsb[b]["FrontTitle"] = TestItems[j].FrontTitle; //主干
              TestItemsb[b]["Type"] = StyleItems[i].Type; //判断是否单选多选
              TestItemsb[b]["StyleID"] = StyleItems[i].StyleID; //"B1型题"
              TestItemsb[b]["AllTestID"] = TestItems[j].AllTestID;
              TestItemsb[b]["BTestID"] = TestItems[j].BTestID;
              TestItemsb[b]["CptID"] = TestItems[j].CptID;
              TestItemsb[b]["IsFav"] = TestItems[j].IsFav;
              TestItemsb[b]["SbjID"] = TestItems[j].SbjID;
              TestItemsb[b]["Score"] = StyleItems[i].Score;
              TestItemsb[b]["SrcID"] = TestItems[j].SrcID;
              TestItemsb[b]["StyleType"] = TestItems[j].StyleType;
              TestItemsb[b]["AnswerArray"] = TestItemsb[b].Answer.split(""); //用于判断答案是否颜色选中
              for (let v in TestItemsb[b].SelectedItems) {
                TestItemsb[b].SelectedItems[v]["open"] = false;
              }
              answerBox.push(TestItemsb[b]);
            }
          }
        }
        if (StyleItems[i].Type == "JDTEST") {
          let TestItems = StyleItems[i].TestItems;
          for (let d in TestItems) {
            TestItems[d]["Style"] = StyleItems[i].Style; //"B1型题"
            TestItems[d]["StyleID"] = StyleItems[i].StyleID; //"B1型题"
            TestItems[d]["Type"] = StyleItems[i].Type;
            answerBox.push(TestItems[d]);
          }
        }
      }

      for (let a in answerBox) {
        //定义储存 题目 下标  匹配到的图片名
        var FrontTitle =
          answerBox[a].FrontTitle != undefined ? answerBox[a].FrontTitle : "";
        let titlebox = {
          title: FrontTitle + answerBox[a].Title,
          index: a,
          img: "",
          ExplainImg: "", //解析图片
          Explain: answerBox[a].Explain, //解析
        };
        //answerBox 把处理数据储存
        that.imgbox.push(titlebox);
        //科目英文编码
        // var APPEName = datas.appEName;//原来
        var APPEName = datas.testData.test.test.ImgAppEName; //2022/4/8修改

        // this.str = answerBox[a].Title
        var regex1 = /\[(.+?)\]/g; // [] 获取题目中括号字符串
        //匹配题目是否有图片名
        let ExplainImg = that.imgbox[a].Explain.match(regex1); //解析
        let imgs = that.imgbox[a].title.match(regex1);
        //把图片名储存在对应imgbox img字段里
        that.imgbox[a]["img"] = imgs;
        that.imgbox[a]["ExplainImg"] = ExplainImg;

        // that.imgbox[a]['img'] 不为空 替换想要的字符串
        if (that.imgbox[a].img != null) {
          //循环储存的图片名，把获取到的图片名，拼接成可以访问的图片路径
          for (let i in that.imgbox[a].img) {
            //图片拼接
            let joiningTogetherImg = `
							    <img  style="max-width:100%;height:auto;vertical-align:middle;" src="http://testimages.ksbao.com/tk_img/ImgDir_${APPEName}/${that.imgbox[
              a
            ].img[i].substr(1, that.imgbox[a].img[i].length - 2)}" />
							    `;
            // that.imgbox[a].title 把替换好的字符串重新赋值
            that.imgbox[a].title = that.imgbox[a].title.replace(
              that.imgbox[a].img[i],
              joiningTogetherImg
            );
          }
        }
        //解析
        if (that.imgbox[a].ExplainImg != null) {
          //循环储存的图片名，把获取到的图片名，拼接成可以访问的图片路径
          for (let i in that.imgbox[a].ExplainImg) {
            //图片拼接
            if (
              that.imgbox[a].ExplainImg[i].indexOf("gif") != -1 ||
              that.imgbox[a].ExplainImg[i].indexOf("bmp") != -1 ||
              that.imgbox[a].ExplainImg[i].indexOf("jpg") != -1 ||
              that.imgbox[a].ExplainImg[i].indexOf("jpeg") != -1 ||
              that.imgbox[a].ExplainImg[i].indexOf("png") != -1
            ) {
              let joiningTogetherImg = `
										<img style="max-width:100%;height:auto;vertical-align:middle;" src="http://testimages.ksbao.com/tk_img/ImgDir_${APPEName}/${that.imgbox[
                a
              ].ExplainImg[i].substr(
                1,
                that.imgbox[a].ExplainImg[i].length - 2
              )}" />
										`;
              // that.imgbox[a].title 把替换好的字符串重新赋值
              that.imgbox[a].Explain = that.imgbox[a].Explain.replace(
                that.imgbox[a].ExplainImg[i],
                joiningTogetherImg
              );
            }
          }
        }
        // //塞入一个新的字段
        answerBox[a]["TitleS"] = that.imgbox[a].title;
        answerBox[a]["Explain"] = that.imgbox[a].Explain;
        //判断选项是否有图片
        for (let i in answerBox[a].SelectedItems) {
          if (answerBox[a].SelectedItems[i].Content.indexOf("[") != -1) {
            //把返回图片名拼接成可以访问的图片
            let joiningTogetherSelecteImg = `
								<img  style="max-width:100%;height:auto;vertical-align:middle;" src="http://testimages.ksbao.com/tk_img/ImgDir_${APPEName}/${answerBox[
              a
            ].SelectedItems[i].Content.substring(
              answerBox[a].SelectedItems[i].Content.indexOf("[") + 1,
              answerBox[a].SelectedItems[i].Content.indexOf("]")
            )}" />
								`;
            var regex2 = /\[(.+?)\]/g; // [] 匹配中括号，正则
            //匹配题目是否有图片名
            let bImg = answerBox[a].SelectedItems[i].Content.match(regex2); //把匹配到的字符串存起来
            for (let j in bImg) {
              answerBox[a].SelectedItems[i].Content = answerBox[
                a
              ].SelectedItems[i].Content.replace(
                bImg[j],
                joiningTogetherSelecteImg
              );
            }

            // answerBox[le].SelectedItems[i].Content=`http://testimages.ksbao.com/tk_img/ImgDir_${that.APPEName}/${answerBox[le].SelectedItems[i].Content.substr(1,answerBox[le].SelectedItems[i].Content.length - 2)}`;
          }
        }
      }

      that.answerBox = answerBox;

      var achievementsBox = JSON.stringify({
        answerBox: answerBox,
        StyleArray: this.assembleData(StyleItems_a, datas.info).QsType,
        accuracy: res.data.accuracy, //正确率
        achievementsDate: res.data.howLongTime, //答题时长
      });
      localStorage.setItem("achievementsBox", achievementsBox);
      localStorage.setItem("HowLongTime", datas.time);
      // that.loadingShow = false; //加载结束
      this.timer = setInterval(this.startTimer, 1000); //考试用时
      function dedupe(array) {
        return Array.from(new Set(array));
      }
      Styledata = dedupe(Styledata);
      that.Styledata = Styledata;
      var tx = [];
      var zf = [];
      var boxarray = [];
      var array = that.answerBox;
      for (var i = 0; i < Styledata.length; i++) {
        var ib = 0;
        var Score = 0;
        var minarray = [];

        for (var aa = 0; aa < array.length; aa++) {
          if (Styledata[i] == array[aa].Style) {
            ib++;
          }
        }
        tx.push(ib);
        boxarray.push(minarray);
        ib = 0;
      }
      this.quantity = tx;

      for (var i = 0; i < tx.length; i++) {
        var indexs = 0;
        for (var aa = 0; aa < array.length; aa++) {
          if (Styledata[i] == array[aa].Style) {
            indexs = indexs + 1;
            array[aa]["indexs"] = indexs;
          } else {
            indexs = 0;
          }
        }
      }
      that.answerBox = array;
      localStorage.setItem("zf", JSON.stringify(zf));

      var quantitydata = [];
      var zfs = [];
      for (let index = 0; index < Styledata.length; index++) {
        var add = {
          Style: Styledata[index],
          quantity: tx[index],
        };
        zfs.push(tx[index]);
        quantitydata.push(add);
      }

      this.zfsData = zfs;
      this.quantitydata = quantitydata;
      localStorage.setItem("quantitydata", JSON.stringify(quantitydata));
      localStorage.setItem("agentCode", datas.agentCode); //代理商编号
      localStorage.setItem("configID", datas.config_id); //试题id
      var examConfigData = {
        configID: datas.config_id,
        TTP: "pc",
      };
        examConfig(examConfigData).then((res) => {
        this.cname = res.data.data.appInfo.cname;
      });
      localStorage.setItem("zfs", JSON.stringify(zfs));
      var s =
        parseInt(new Date(this.newDate(datas.create_time)).getTime()) +
        parseInt(datas.time * 1000);
      this.referringTime = this.timestampToTime(s); //交卷的时间
      this.duration = this.durations(parseInt(datas.time)); //答题时长
      this.totalQuantity = datas.testData.test.test.length; //总题量
      this.scoreBox = datas.score; //得分
      this.accuracyBox = datas.accuracy;

      this.accuracyPercentage = parseInt(datas.accuracy.replace("%", ""));

      //可视化图需要的数据
      var myChartdata = this.assembleData(StyleItems_a, datas.info).analysisRes;
      this.myChartdata = myChartdata;
      this.proportionData = (
        this.myChartdata.ARFields[0].max / this.totalQuantity
      ).toFixed(1); //题目比重 （题型数/总题数）%
      this.accuracyData = (
        this.myChartdata.RightCount[0] / this.myChartdata.ARFields[0].max
      ).toFixed(1);
      //准确率：x% （题型正确数/题型数）%
      this.masteryDegree(); //掌握程度
      this.getEchartData(myChartdata);
      
      // 初始化章节展开状态数组
      this.$nextTick(() => {
        this.resetAllExpandedChapters();
      });
    });
  },
  methods: {
    toHome() {
      this.$router.push({ path: "/" });
    },
    newDate(time) {
      var date = new Date(time);
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      m = m < 10 ? "0" + m : m;
      var d = date.getDate();
      d = d < 10 ? "0" + d : d;
      return `${y}-${m}-${d} 00:00:00`;
    },

    //掌握程度
    masteryDegree() {
      // 不足（60%以下）/了解（61%-70%）/熟悉（71%-80%）/掌握（81%-90%）/精通（91%及以上）
      var accuracyName = this.accuracyData * 100;
      if (accuracyName < 60) {
        this.accuracyNameBox = "不足";
      }
      if (accuracyName > 60 && accuracyName < 70) {
        this.accuracyNameBox = "了解";
      }
      if (accuracyName > 71 && accuracyName < 80) {
        this.accuracyNameBox = "熟悉";
      }
      if (accuracyName > 81 && accuracyName < 90) {
        this.accuracyNameBox = "掌握";
      }
      if (accuracyName > 91) {
        this.accuracyNameBox = "精通";
      }
    },
    //处理数据，查看解析
    assembleData(target, insertObj) {
      let testObj = {};
      insertObj.forEach((e) => {
        if (!e.ChildTableID || e.ChildTableID.toString() == "-1") {
          testObj[e.AllTestID.toString()] = e;
        } else {
          testObj[e.ChildTableID.toString()] = e;
        }
      });
      //组装空对象
      let res = [];
      //总分统计
      let totalScore = 0;
      //题目类型
      let QsType = {};
      //分析结果
      let analysisRes;
      let tempAR = {};
      let score = 0;

      target.forEach((ee) => {
        totalScore += Number(ee.Score);
        QsType[ee.Style] = 0;
        // let type=QSTypeConventor(ee)
        if (tempAR[ee.Style]) {
          tempAR[ee.Style].max++;
        } else {
          tempAR[ee.Style] = {
            max: 1,
            value: 0,
            rightCount: 0,
          };
        }
        let answer;
        if (ee.Type == "ATEST" || ee.Type == "XTEST") {
          let key = ee.AllTestID.toString();
          if (testObj[key]) {
            answer = ee.TestItems[0].Answer;

            if (answer == testObj[key].ItemName) {
              tempAR[ee.Style].value += Number(ee.Score);
              score++;
              tempAR[ee.Style].rightCount++;
            }
            res.push(JSON.parse(JSON.stringify(testObj[key])));
          } else {
            res.push({
              ItemName: "",
              // group: "",
            });
          }
        } else if (ee.Type == "A3TEST") {
          let key = ee.TestItems[0].A3TestID.toString();
          if (testObj[key]) {
            answer = ee.TestItems[0].A3TestItems[0].Answer;
            if (answer == testObj[key].ItemName) {
              tempAR[ee.Style].value += Number(ee.Score);
              score++;
              tempAR[ee.Style].rightCount++;
            }
            res.push(JSON.parse(JSON.stringify(testObj[key])));
          } else {
            res.push({
              ItemName: "",
              // group: "",
            });
          }
        } else if (ee.Type == "BTEST") {
          let key = ee.TestItems[0].BTestID.toString();

          if (testObj[key]) {
            answer = ee.TestItems[0].BTestItems[0].Answer;
            if (answer == testObj[key].ItemName) {
              tempAR[ee.Style].value += Number(ee.Score);
              score++;
              tempAR[ee.Style].rightCount++;
            }
            res.push(JSON.parse(JSON.stringify(testObj[key])));
          } else {
            res.push({
              ItemName: "",
              // group: "",
            });
          }
        }
      });

      //属性
      let ARFields = [];
      //值
      let ARValues = [];
      let RightCount = [];
      let ARKeys = Object.keys(tempAR);
      ARKeys.forEach((k) => {
        ARFields.push({
          text: k,
          max: tempAR[k].max,
        });
        ARValues.push(tempAR[k].value);
        RightCount.push(tempAR[k].rightCount);
      });
      analysisRes = {
        ARFields: ARFields,
        ARValues: ARValues,
        RightCount: RightCount,
      };
      return {
        info: res,
        totalScore: totalScore,
        QsType: Object.keys(QsType),
        analysisRes: analysisRes,
      };
    },
    QSTypeConventor(obj) {
      if (obj.Type == "ATEST") {
        return "单选";
      } else if (obj.Type == "XTEST") {
        return "多选";
      } else if (obj.Type == "BTEST" || obj.Type == "A3TEST") {
        if (obj.SubType == "" || obj.SubType == "单项") {
          return "单选";
        } else {
          return "多选";
        }
      } else if (obj.Type == "Type-JDTEST") {
        return "简单题";
      } else if (obj.Type == "Type-PDTEST") {
        return "判断题";
      }
    },
    //时间戳转时间
    timestampToTime(timestamp) {
      var date = new Date(timestamp); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      var Y = date.getFullYear() + "-";
      var M =
        (date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1) + "-";
      var D = date.getDate() + " ";
      var h = date.getHours() + ":";
      var m = date.getMinutes() + ":";
      var s = date.getSeconds();

      return Y + M + D + h + m + s;
    },
    //用时
    durations(second_time) {
      var time = parseInt(second_time) + "秒";
      if (parseInt(second_time) > 60) {
        var second = parseInt(second_time) % 60;
        var min = parseInt(second_time / 60);
        time = min + "分" + second + "秒";
        if (min > 60) {
          min = parseInt(second_time / 60) % 60;
          var hour = parseInt(parseInt(second_time / 60) / 60);
          time = hour + "小时" + min + "分" + second + "秒";
        }
      }
      return time;
    },
    getEchartData(myChartdata) {
      // 基于准备好的dom，初始化echarts实例
      var chartDom = this.$refs.main;
      var myChart = echarts.init(chartDom);
      // 绘制图表
      myChart.setOption({
        title: {
          text: "",
        },

        radar: [
          {
            indicator: myChartdata.RightCount,
            center: ["50%", "45%"],
            radius: 58,
            shape: "circle",
          },
        ],
        series: [
          {
            type: "radar",
            tooltip: {
              trigger: "item",
            },
            areaStyle: {},
            data: [
              {
                value: myChartdata.RightCount,
                name: "统计",
                label: {
                  normal: {
                    show: true,
                  },
                },
                areaStyle: {
                  //  color: ['#77EADF', '#26C3BE', '#64AFE9', '#428BD4'],
                  color: new echarts.graphic.RadialGradient(1, 1, 1, [
                    {
                      color: "#ECF1FE",
                      offset: 0,
                    },
                    {
                      color: "#ECF1FE",
                      offset: 1,
                    },
                  ]),
                },
              },
            ],
          },
        ],
      });
    },
    scrollToTop() {
      // var scrollTop =
      //   window.pageYOffset ||
      //   document.documentElement.scrollTop ||
      //   document.body.scrollTop;
    },
    //滚动条事件
    handleScroll(e) {
      // const scrollTop = this.$refs.app.scrollTop;
      
      // 动态获取当前页面对应的container，如果不存在则跳过
      const appMap = {
        0: this.$refs.app1,
        1: this.$refs.app2,
        2: this.$refs.app3,
        3: this.$refs.app4,
        4: this.$refs.app5,
        5: this.$refs.app6
      };
      
      var container = appMap[this.initial];
      
      // 检查container是否存在，如果不存在则跳过处理
      if (!container) {
        return;
      }
      
      var scrollTop = container.scrollTop;
      var windowHeight = container.clientHeight;
      var scrollHeight = container.scrollHeight;
      if (scrollTop + windowHeight == scrollHeight) {
        setTimeout(() => {}, 1500);
      } else {
      }
    },
    swiperup: function () {
      if (this.initial != "5") {
        this.initial = parseInt(this.initial) + 1 + "";
      }
    },
    swiperupLeft() {
      if (this.initial != "0") {
        this.initial = parseInt(this.initial) - 1 + "";
      }
    },
    swiperdown: function () {},
    swipes(index) {},
    //点击查看滑到第二页
    lookOverClick() {
      this.initial = "1";
    },
    //点击题干
    questionTypesClick(index, item) {
      this.indexs = index;
      this.proportionData = (
        this.myChartdata.ARFields[index].max / this.totalQuantity
      ).toFixed(1); //题目占比：x%（题型数/总题数）%
      this.accuracyData = (
        this.myChartdata.RightCount[index] /
        this.myChartdata.ARFields[index].max
      ).toFixed(2); //准确率：x% （题型正确数/题型数）%

      this.masteryDegree(); //掌握程度
    },
    reView() {
      this.initial = "0";
    },
    //点击查看解析
    examineClick() {
      this.$router.push({ path: "/answerView", query: {} });
    },
    //切换章节展开/收起状态
    toggleChapter(index) {
      // 确保 expandedChapters 数组长度与 chapter 数组一致
      this.ensureExpandedChaptersLength();
      // 切换指定章节的展开状态
      this.$set(this.expandedChapters, index, !this.expandedChapters[index]);
    },
    //确保展开状态数组长度正确
    ensureExpandedChaptersLength() {
      if (this.expandedChapters.length !== this.chapter.length) {
        this.expandedChapters = new Array(this.chapter.length).fill(false);
      }
    },
    //重置所有章节展开状态
    resetAllExpandedChapters() {
      if (this.chapter?.length > 0) {
        this.expandedChapters = new Array(this.chapter.length).fill(false);
      }
    },
  },
};
</script>
<style  scoped>
.box >>> .van-swipe-item {
  height: 100vh !important;
  /* background: #ccc; */
  overflow: scroll;
  position: relative;
}
.box >>> .van-nav-bar .van-icon {
  color: #333;
  font-size: 50px;
}
.contentArea {
  width: 100vw;
  height: calc(100vh - 190px) !important;
  overflow: scroll !important;
  position: absolute;
  top: 0;
  left: 0;
  background: linear-gradient(125deg, #badafb 0%, #f1f6ff 100%);
}
.contentArea_a {
  width: 100vw;
  height: calc(100vh - 100px) !important;
  overflow: scroll !important;
  position: absolute;
  top: 0;
  left: 0;
}
.contentArea_as {
  width: 100vw;
  height: 100vh !important;
  overflow: scroll !important;
  position: absolute;
  top: 0;
  left: 0;
  background: #fff;
}
.examine {
  width: 100vw;
  position: fixed;
  bottom: 0;
  background-color: #deecfd;
  background: linear-gradient(125deg, #deecfd 0%, #f1f6ff 100%);
  height: 100px;
  text-align: center;
}
.examines {
  width: 100vw;
  position: fixed;
  bottom: 0;
  background-color: #fff;
  background: linear-gradient(125deg, #fff 0%, #fff 100%);
  height: 100px;
  text-align: center;
  display: flex;
  justify-content: space-around;
  padding-top: 20px;
}
.examines_a {
  width: 332px;
  height: 76px;
  border-radius: 48px;
  border: 2px solid #bfbfbf;
  font-size: 32px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #333333;
  text-align: center;
  line-height: 76px;
}
.examines_b {
  width: 332px;
  height: 76px;
  background: linear-gradient(97deg, #5a87fd 0%, #3e73f7 100%);
  border-radius: 48px;
  font-size: 32px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #ffffff;
  text-align: center;
  line-height: 76px;
}
.v-touch {
  height: 100px;
  font-size: 28px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #3e73f7;
  /* background: greenyellow; */
}
.v-touch img {
  width: 34px;
  height: 32px;
  margin: 0 auto;
  margin-bottom: 10px;
}
.swipeItem_a {
  width: 100vw;
  height: 726px;
  background: url("../assets/bg2.png");
  background-size: 100% 100%;
  position: relative;
}
.swipeItem_title {
  font-size: 34px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
  text-align: center;
  padding-top: 108px;
  padding-bottom: 208px;
}
.swipeItem_titleA {
  padding-left: 32px;
}
.determine {
  font-size: 52px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #3e73f7;
}
.subject {
  font-size: 34px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
  padding-top: 24px;
}
.swipeItem_a_img {
  width: 246px;
  height: 480px;
  position: absolute;
  right: 0;
  bottom: -310px;
}
.swipeItem_a_img img {
  width: 246px;
  height: 480px;
}
.lookOver {
  width: 572px;
  height: 96px;
  background: linear-gradient(97deg, #5a87fd 0%, #3e73f7 100%);
  border-radius: 48px;
  margin: 0 auto;
  margin-top: 478px;
  font-size: 34px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #ffffff;
  text-align: center;
  line-height: 96px;
}
.bulletin {
  padding: 0 32px;
}
.circumstances {
  font-size: 36px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 550;
  color: #002a61;
  margin-top: 40px;
  padding-left: 16px;
  border-left: 6px solid #002a61;
  margin-bottom: 32px;
}
.circumstancestime {
  font-size: 28px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
  margin-bottom: 10px;
}
.circumstancestime span {
  color: #389e0d;
}
.fruit {
  height: 412px;
  background: #ffffff;
  box-shadow: 0px 4px 16px 0px rgba(196, 223, 251, 0.44);
  border-radius: 16px;
  margin-top: 30px;
  padding: 16px;
}
.fruitOutside {
  display: flex;
  height: 80px;
  border-bottom: 2px solid #f5f5f5;
}
.fruitOutside_a {
  width: 40%;
  text-align: center;
  background: #ebf2ff;
  line-height: 80px;
  font-size: 28px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
}
.fruitOutside_b {
  width: 60%;
  padding-left: 100px;
  font-weight: 500;
  color: #333333;
}
.fruit_a {
  border-radius: 4px;
  border: 2px solid #f5f5f5;
  line-height: 80px;
  font-size: 28px;
  border-bottom: 0;
}
.summarizeBriefly {
  font-size: 28px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
  margin-top: 40px;
}
.summarizeBriefly span {
  color: #ff7333;
}
.analyticResult {
  background: #ffffff;
  box-shadow: 0px 4px 16px 0px rgba(196, 223, 251, 0.44);
  border-radius: 16px;
  margin: 0 32px;
  padding: 16px 18px;
}
.circumstances_a {
  margin-left: 32px;
}
.result {
  /* height: 366px; */
  background: #ffffff;
  border-radius: 4px;
  border: 2px solid #f5f5f5;
  border-bottom: 0;
}
.resultCell {
  display: flex;
  text-align: center;
  min-height: 72px;        /* 使用最小高度而不是固定高度，以适应多行文本 */
  line-height: 72px;       /* 这个可以保持，用于单行文本的垂直居中 */
  border-bottom: 2px solid #f5f5f5;
  font-size: 28px;
  color: #333;
}
.resultCell_a {
  width: 35%;
  border-right: 2px solid #f5f5f5;
}
.resultCell_b {
  width: 45%;
  border-right: 2px solid #f5f5f5;
}
.resultCell_c {
  width: 20%;
}
.resultCell_fz div {
  background: #ebf2ff;
  font-weight: 600;
  color: #333;
}
.resultCell_chapter div {
  background: #ebf2ff;
  color: #333;
}
.viewParsing {
  width: 232px;
  height: 72px;
  border-radius: 40px;
  border: 2px solid #3f74f7;
  margin: 0 auto;
  font-size: 28px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #3e73f7;
  text-align: center;
  line-height: 72px;
  margin: 0 auto;
  margin-top: 50px;
  /* margin-bottom: 30px; */
}
.interpretation {
  background: #f5f5f5;
  border-radius: 8px;
  padding: 20px;
  font-size: 28px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
}
.interpretation_title {
  font-size: 28px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 600;
  color: #333333;
}
.questionTypes {
  display: flex;
  flex-wrap: wrap;
}
.questionTypes_a {
  background: #f0f0f0;
  border-radius: 38px;
  padding: 12px 32px;
  margin-right: 32px;
  margin-bottom: 15px;
  margin-top: 15px;
  color: #333;
}
.questionTypes_as {
  border-radius: 38px;
  padding: 12px 32px;
  margin-right: 32px;
  margin-bottom: 15px;
  margin-top: 15px;
  background: #3e73f7;
  color: #fff;
}

.proportion {
  display: flex;
  justify-content: space-between;
  font-size: 28px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
  margin-bottom: 20px;
  margin-bottom: 16px;
  margin-top: 60px;
}

.proportionBox >>> .van-progress__pivot {
  position: absolute;
  top: -500000000000000000000% !important;
}
.proportion_a {
  font-weight: 600;
}
.proportionBox {
  margin-top: 40px;
}
.level {
  font-weight: 600;
  font-size: 28px;
  font-family: PingFangSC-Medium, PingFang SC;
  color: #333333;
  margin-top: 60px;
}
.degree {
  display: flex;
  justify-content: space-between;
  position: relative;
  margin-top: 10px;
  margin-bottom: 80px;
}
.degree_a {
  width: 120px;
  text-align: center;
}
.handstand {
  height: 0;
  width: 0px;
  border-top: 15px solid #59d9a7;
  border-left: 15px solid transparent;
  border-right: 15px solid transparent;
  margin-left: 40px;
  margin-bottom: 10px;
}
.handstands {
  height: 0;
  width: 0px;
  border-top: 15px solid #fff;
  border-left: 15px solid transparent;
  border-right: 15px solid transparent;
  margin-left: 40px;
  margin-bottom: 10px;
}
.degree_jd {
  width: 120px;
  height: 18px;
  background: #f0f0f0;
  margin-bottom: 10px;
}
.degree_jds {
  width: 120px;
  height: 18px;
  background: #59d9a7;
  margin-bottom: 10px;
}
.degree_title {
  font-size: 28px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #666666;
}
.analyticResult_summarize {
  font-size: 28px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
}
.analyticResult_summarizes {
  margin-bottom: 200px;
}
.swiperupCls span {
  background: #5a87fd;
  padding: 15px 50px;
  border-radius: 16px;
  color: #fff;
  cursor: pointer;
}
.swiperupCls_a {
  margin-right: 20px;
}
.bulletin_average {
  font-size: 28px;
}
.circumstances_a {
  margin-bottom: 20px;
}
.circumstances_b {
  margin-left: 0;
  margin-bottom: 40px;
}
.average {
  padding-bottom: 10px;
}
.average span {
  font-weight: 600;
}
.childChapter {
  background-color: #f9f9f9;
  border-left: 3px solid #3e73f7;
  align-items: center;
}
.childChapter .resultCell_a {
  color: #666;
  font-size: 26px;
  white-space: normal;      /* 允许文本换行 */
  word-wrap: break-word;     /* 允许长单词或URL在任意位置换行 */
  word-break: break-all;     /* 允许在单词内部换行，对中文也有帮助 */
  padding: 8px 2px;          /* 增加上下内边距，使多行文本更美观 */
  line-height: 1.4;          /* 设置合适的行高，使多行文本更易读 */
}
.resultCell_chapter .resultCell_a {
  cursor: pointer;
  transition: background-color 0.2s;
}
.resultCell_chapter .resultCell_a:hover {
  background-color: #f0f7ff;
}
.icon-arrow-down {
 margin-left: 2px;
 font-size: 18px;
 transition: transform 0.2s;
}
.icon-arrow-right {
 margin-left: 2px;
 font-size: 18px;
}
</style>